<template>
  <div class="drawLots" v-loading="loading">
    <div class="h1">本届展会共有{{allUnitNum}}家展商完成预报名，其中理事单位{{lsdwNum}}家</div>
    <div class="timer_box">
      <div class="container">
        <el-form :model="form" :rules="rules" ref="form" label-width="0">
          <el-row class="row_box" v-for="(item, index) in form.dataList" :key="index">
            <div class="one_box">{{item.pc}}：</div>
            <div class="two_box">
              <el-form-item :prop="'dataList.' + index + '.sl'" :rules="rules.sl">
                <el-input-number v-model="item.sl" size="small" style="width:100%" :min="0" :placeholder="item.pc" @change="(currentValue, oldValue) => {inputNumChange(currentValue, oldValue, item, index)}"></el-input-number>
              </el-form-item>
            </div>
            <div class="three_box">家</div>
            <div class="four_box">展位选择时间：</div>
            <div class="five_box">
              <el-form-item :prop="'dataList.' + index + '.timer'" :rules="rules.timer">
                <el-date-picker v-model="item.timer" value-format="yyyy-MM-dd HH:mm:ss" size="small" @change="(val) => {getTimer(val, item, item)}" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
              </el-form-item>
            </div>
            <div class="row_button">
              <el-button v-if="index !== 0 && form.dataList.length == index + 1" style="color:#f56c6c;font-size: 16px;padding:0;" type="text" icon="el-icon-delete" size="small" @click="toDelete(item, index)"></el-button>
              <el-button v-if="form.dataList.length == index + 1" style="color:#333;font-size: 16px;padding:0;" type="text" icon="el-icon-circle-plus-outline" size="small" @click="toAdd"></el-button>
            </div>
          </el-row>
        </el-form>
      </div>
      <div class="footer">
        <el-button type="clear" icon="el-icon-close" size="small" class="btn_submit" @click="toReset">取消</el-button>
        <el-button type="success" icon="el-icon-check" size="small" @click="toSubmit">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        dataList: [{
          xh: 1,
          sl: 0,
          pc: `第一批`,
          kssj: "",
          jssj: "",
          timer: [],
        }]
      },
      rules: {
        sl: [{
          required: true,
          message: "请填写批次数量",
          trigger: "blur",
        }],
        timer: [{
          required: true,
          message: "请选择时间",
          trigger: "change",
        }]
      },
      allUnitNum: 0,
      lsdwNum: 0,
      // 记录修改数据
      editArr: [],
      // 记录删除数据
      deleteArr: [],
      // 记录新增数据
      addArr: [],
      // loading
      loading: false
    }
  },
  created () {
    this.getNums()
    this.getDataList()
  },
  methods: {
    // 获取数据
    getDataList () {
      this.loading = true
      this.$axios.post("cfpayhsz/list", {}).then(res => {
        this.loading = false
        if (res.data.code == "00000000") {
          if (res.data.result.length > 0) {
            this.form.dataList = res.data.result.map(item => {
              return {
                ...item,
                timer: item.kssj || item.jssj ? [item.kssj ? item.kssj : "", item.jssj ? item.jssj : ""] : null
              }
            })
          } else {
            this.form.dataList = [{
              xh: 1,
              sl: 0,
              pc: `第一批`,
              kssj: "",
              jssj: "",
              timer: [],
            }]
          }
        }
      })
    },
    // 获取数量
    getNums () {
      this.$axios.post("qyjbxx/selectZsbmnumLsdwnumCount", {}).then(res => {
        if (res.data.code == "00000000") {
          this.allUnitNum = res.data.result.zsbmnum
          this.lsdwNum = res.data.result.lsdwnum
        }
      })
    },
    // 删除一行
    toDelete (item, index) {
      this.$confirm("确认删除当前摇号设置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.form.dataList.splice(index, 1)
        if (item.uuid) {
          this.deleteArr.push({
            ...item,
            xgrid: this.CONSTANT.currentUser.userid,
            xgrmc: this.CONSTANT.currentUser.realname
          })
          let UUindex = this.editArr.map(item => item.uuid).indexOf(item.uuid)
          if (UUindex > -1) {
            this.editArr.splice(UUindex, 1)
          }
        }
      })
    },
    // 增加一行
    toAdd () {
      this.$set(this.form.dataList, this.form.dataList.length, {
        xh: this.form.dataList.length + 1,
        sl: 0,
        pc: `第${this.TransformToChinese(this.form.dataList.length + 1)}批`,
        kssj: "",
        jssj: "",
        timer: [],
        cjrid: this.CONSTANT.currentUser.userid,
        cjrmc: this.CONSTANT.currentUser.realName,
      })
    },
    // 改变inputNum
    inputNumChange (val, oldVal, item, index) {
      if (item.uuid) {
        let UUindex = this.editArr.map(item => item.uuid).indexOf(item.uuid)
        if (UUindex == -1) {
          this.editArr.push({
            ...item,
            xgrid: this.CONSTANT.currentUser.userid,
            xgrmc: this.CONSTANT.currentUser.realname
          })
        } else {
          this.editArr[UUindex].sl = val
        }
      }
    },
    // 获取时间
    getTimer (val, item, index) {
      item.kssj = val[0]
      item.jssj = val[1]
      if (item.uuid) {
        let UUindex = this.editArr.map(item => item.uuid).indexOf(item.uuid)
        if (UUindex == -1) {
          this.editArr.push({
            ...item,
            xgrid: this.CONSTANT.currentUser.userid,
            xgrmc: this.CONSTANT.currentUser.realname
          })
        } else {
          this.editArr[UUindex].kssj = val[0]
          this.editArr[UUindex].jssj = val[1]
          this.editArr[UUindex].timer = val
        }
      }
    },
    // 重置
    toReset () {
      this.deleteArr = []
      this.editArr = []
      this.addArr = []
      this.getDataList()
    },
    // 提交
    toSubmit () {
      let slArr = this.form.dataList.map(item => item.sl)
      let slCount = slArr.reduce((pre, cur) => {return pre + cur})
      if (slCount < this.allUnitNum) {
        //return this.$message.warning("当前所有批次数量总和小于预报名展商数")
        return this.$message.warning("完成预报名的展商未分配完！")
      }
      if (this.lsdwNum > this.form.dataList[0].sl) {
        //return this.$confirm("当前理事单位数大于第一批数量，是否确认保存?", "提示", {
        return this.$confirm("当前设置不能满足"+this.lsdwNum+"家理事单位均处在第一批次，是否确认保存?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.submit();
        })
      }
      this.submit();
    },
    submit () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.addArr = this.form.dataList.filter(item => {if (!item.uuid) return item})
          let data = {
            insertCfpaYhSzVO: this.addArr,
            updateCfpaYhSzVO: this.editArr,
            deleteCfpaYhSzVO: this.deleteArr
          }
          this.$axios.post("cfpayhsz/saveYhsz", data).then(res => {
            if (res.data.code == "00000000") {
              this.$message.success("保存成功！")
              this.getDataList()
            } else {
              this.$message.error("保存失败，请稍后再试")
            }
          })
        }
      })
    },
    // 数字转换位对应汉字
    TransformToChinese(num) {
      const texts = { 0: '零', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '七', 8: '八', 9: '九' }
      const units = {10: '十', 100: '百', 1000: '千', 10000: '万'}
      // 最后的返回值
      let res = ''
      // 处理的最后一位数字
      let singleNum = 0
      // 上一次处理的最后一位数字
      let prevSingleNum = -1
      // 当前正在处理的位数
      let unitNum = 1
      // 对原始值进行一个隔离
      let _num = num
      // 处理之后得到的汉字数组
      let numTexts = []
      while(_num){
        // 这里利用取余获得每次处理最后一位数字
        singleNum = _num % 10
        if (units[unitNum] && singleNum !== 0) {
          numTexts.unshift(units[unitNum])
        }
        if((unitNum === 1 && singleNum !== 0) || (unitNum !== 1 && num >= 20)){
          if (!(prevSingleNum === 0 && singleNum === 0)) {
            numTexts.unshift(texts[singleNum])
          }
        }
        // 这里处理完之后将会增加位数
        unitNum *= 10
        // 利用向下取整获得接下来需要处理的新的数值
        _num = Math.floor(_num / 10)
        // 记录下本次处理的最后一位数字
        prevSingleNum = singleNum
      }
      res = numTexts.join('')
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.drawLots {
  padding: 20px 140px;
  .h1 {
    font-size: 18px;
    font-weight: bold;
  }
  .container {
    width: 100%;
    margin-top: 20px;
    .row_box {
      font-size: 16px;
      width: 100%;
      height: 45px;
      line-height: 45px;
      display: flex;
      .one_box {
        width: 9rem;
        padding: 0 10px;
        text-align: right;
      }
      .three_box {
        width: 2rem;
        padding-left: 15px;
      }
      .four_box {
        width: 13rem;
        padding-right: 10px;
        text-align: right;
      }
      .five_box {
        min-width: 20rem;
      }
    }
    .row_button {
      width: 10rem;
      height: 45px;
      line-height: 45px;
      padding-left: 20px;
    }
  }
  .timer_box {
    width: 100%;
    .footer {
      width: 100%;
      text-align: center;
      margin: 20px 0;
    }
  }
  /deep/ .el-form-item__content {
    line-height: 45px;
  }
}
@media screen and (max-width: 1400px) {
  .drawLots {
    padding: 20px 40px;
    .container {
      .row_box {
        font-size: 12px;
        .one_box {
          width: 8rem;
          padding: 0 10px;
          text-align: right;
        }
        .four_box {
          width: 10rem;
          padding-right: 10px;
          text-align: right;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .drawLots {
    padding: 20px;
    .container {
      .row_box {
        font-size: 12px;
        .one_box {
          width: 8rem;
          padding: 0 10px;
          text-align: right;
        }
        .four_box {
          width: 10rem;
          padding-right: 10px;
          text-align: right;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/drawLots/drawLotsSetting.vue